import reducer, {
  initialSettings,
  /* eslint-disable-next-line import/no-named-as-default */
} from '../../../theme/store/reducers/settings.reducer';

// Types
import type {
  $ActionEnvelope,
  $ReducerActions,
} from '../..';

const initialState = initialSettings;

export type $State = typeof initialState;

export type $Reducer = (
  arg0: $State,
  arg1: $ActionEnvelope<$ReducerActions<$State>>,
) => $State;

export {
  initialState,
};

export default reducer;
